import { useMemo } from "react";

import { useConvertPaymentMethodText } from "../../../_hooks";

import type * as Repository from "../../../_repository";
import type * as Type from "../type";

type Props = {
	option: Repository.Query.QueryData.OptionPmsList.Option;
};
type Result = {
	viewData: Type.ViewData;
};

export const useViewDataConverter = ({
	option: {
		date,
		guestName,
		guestTel,
		roomNum,
		subOptionName,
		optionName,
		amount,
		planName,
		paymentMethod,
		questions,
	},
}: Props): Result => {
	const { onConvertPaymentMethodText } = useConvertPaymentMethodText();

	const guestTotalNumberText = useMemo(() => {
		if (!roomNum) return "";

		const adultNum = roomNum.reduce((acc, curr) => acc + curr.adultNum, 0);

		let totalNumberText = `大人 ${adultNum}人`;

		const kidsNum = roomNum.reduce((acc, curr) => acc + curr.kidsNum.length, 0);
		if (kidsNum > 0) {
			// 子どもが存在する場合
			totalNumberText = `${totalNumberText}, 子ども ${kidsNum}人`;
		}

		const kidsCosleepingNum = roomNum.reduce(
			(acc, curr) => acc + curr.kidsNum.filter((kid) => kid.asCosleeping).length,
			0,
		);
		if (kidsCosleepingNum > 0) {
			// 添い寝の子どもが存在する場合
			totalNumberText = `${totalNumberText} 子ども ${kidsCosleepingNum}人 ※添い寝（${kidsCosleepingNum}人）`;
		}

		return totalNumberText;
	}, [roomNum]);

	return useMemo(
		() => ({
			viewData: {
				dateText: date,
				guestNameText: `${guestName} 様`,
				guestTellText: guestTel ?? "",
				guestTotalNumberText,
				optionNameText: subOptionName ? `${optionName} | ${subOptionName}` : optionName,
				amountText: `${amount}個`,
				planNameText: planName ?? "手動入力",
				paymentMethodText: onConvertPaymentMethodText(paymentMethod ?? null),
				questions: questions ?? [],
			},
		}),
		[
			amount,
			date,
			guestName,
			guestTel,
			guestTotalNumberText,
			onConvertPaymentMethodText,
			optionName,
			paymentMethod,
			planName,
			questions,
			subOptionName,
		],
	);
};
